
export const TORAH_ORDER = [
    'Bereishit',
    'Shemot',
    'Vayikra',
    'Bamidbar',
    'Devarim',
    'Holidays'
];

export const TORAH_ORDER_HEBREW = [
    'בראשית',
    'שמות',
    'ויקרא',
    'במדבר',
    'דברים',
    'חגים'
];

export const PARASHA_BEREISHIT_ORDER = [
  'בראשית',
  'נח',
  'לך לך',
  'וירא',
  'חיי שרה',
  'תולדות',
  'ויצא',
  'וישלח',
  'וישב',
  'מקץ',
  'ויגש',
  'ויחי'
];

export const PARASHA_SHEMOT_ORDER = [
  'שמות',
  'וארא',
  'בא',
  'בשלח',
  'יתרו',
  'משפטים',
  'תרומה',
  'תצווה',
  'כי תשא',
  'ויקהל',
  'פקודי'
];

export const PARASHA_VAYIKRA_ORDER = [
  'ויקרא',
  'צו',
  'שמיני',
  'תזריע',
  'מצורע',
  'אחרי מות',
  'קדושים',
  'אמור',
  'בהר',
  'בחוקותי'
];

export const PARASHA_BAMIDBAR_ORDER = [
  'במדבר',
  'נשא',
  'בהעלותך',
  'שלח',
  'קרח',
  'חקת',
  'בלק',
  'פנחס',
  'מטות',
  'מסעי'
];

export const PARASHA_DEVARIM_ORDER = [
  'דברים',
  'ואתחנן',
  'עקב',
  'ראה',
  'שופטים',
  'כי תצא',
  'כי תבוא',
  'ניצבים',
  'וילך',
  'האזינו',
  'וזאת הברכה'
];

export const PARASHA_HOLIDAYS_ORDER = [
    'ראש השנה',
    'יום כיפור',
    'סוכות',
    'שמחת תורה',
    'פורים',
    'פסח',
    'שבועות'
]

export const PARASHA_ORDER_MAP = {
  בראשית: PARASHA_BEREISHIT_ORDER,
  שמות: PARASHA_SHEMOT_ORDER,
  ויקרא: PARASHA_VAYIKRA_ORDER,
  במדבר: PARASHA_BAMIDBAR_ORDER,
  דברים: PARASHA_DEVARIM_ORDER,
  חגים: PARASHA_HOLIDAYS_ORDER
};

export const SPECIAL_PARASHA_KEYS = ['נח', 'לך לך', 'חיי שרה'];


export const TEMP_CARDS = [
  {
    id: 'bereshit',
    name:'בראשית'
  },
  {
    id: 'shemot',
    name:'שמות'
  },
  {
    id: 'vayikra',
    name:'ויקרא'
  },
  {
    id: 'bamidbar',
    name:'במדבר'
  },
  {
    id: 'devarim',
    name:'דברים'
  },
  {
    id: 'holidays',
    name:'חגים'
  }
]